export default __webpack_public_path__ + "static/media/sample-device-small.a9df1276.svg";